import { render, staticRenderFns } from "./comp_CheckoutStep-confirm.vue?vue&type=template&id=39b18d91&scoped=true&"
import script from "./comp_CheckoutStep-confirm.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-confirm.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-confirm.vue?vue&type=style&index=0&id=39b18d91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b18d91",
  null
  
)

export default component.exports